// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hallmark · shape: app screen · genre: modern-minimal · theme: brand · redesign: full
 * paper: #ffffff · accent: #4461f2 · display: DM Sans · body: DM Sans
 * nav: kept (Dashlite shell) · signature: the three-pane inbox of chat-platform · states: loading, empty, no access, full
 * axes: white/dm-sans/blue · posture: settled · contrast: pass · v2.0.0 */
/* Hallmark · pre-emit critique: P4 H4 E4 S3 R4 V4 · weakest: S, the inbox is a twin of chat-platform by request, the sidebar badges carry the Live Chat difference */
/* base.css is not imported: a global reset would restyle every CRM page; its focus and motion rules are scoped to .lc-root below */

:root {
  --lc-accent: #4461f2;
  --lc-accent-ink: #ffffff;
  --lc-paper: #ffffff;
  --lc-paper-2: #f5f6fa;
  --lc-paper-3: #e5e9f2;
  --lc-ink: #364a63;
  --lc-ink-2: #526484;
  --lc-muted: #8094ae;
  --lc-note: #fff7d6;
  --lc-note-rule: #f4bd0e;
  --lc-system: #485fee;
  --lc-danger: #c4323f;
  --lc-holder: #f7f5f5;
  --lc-holder-rule: #050505;
  --lc-focus: #4461f2;
  --lc-font: "DM Sans", sans-serif;
  --lc-dur: 120ms;
}

.lc-root {
  font-family: var(--lc-font);
}

.lc-root :focus-visible {
  outline: 2px solid var(--lc-focus);
  outline-offset: 2px;
}

.lc-root .lc-tab {
  height: 40px;
  cursor: pointer;
  color: var(--lc-ink);
}

.lc-root .lc-tab.is-active {
  color: var(--lc-accent);
}

.lc-root .lc-search {
  background-color: var(--lc-paper-3);
  margin-bottom: 16px;
}

.lc-root .lc-filter-on {
  background-color: var(--lc-accent);
  color: var(--lc-accent-ink);
}

.lc-root .lc-filter-menu {
  min-width: 220px;
  max-height: 320px;
  overflow-y: auto;
}

.lc-root .lc-item.is-selected {
  background-color: var(--lc-paper-2);
}

.lc-root .lc-preview.is-unread {
  color: var(--lc-ink);
  font-weight: 700;
}

.lc-root .lc-msg {
  max-width: 425px;
  min-width: 120px;
  font-size: 15px;
  white-space: pre-line;
  overflow-wrap: break-word;
}

.lc-root .lc-system {
  max-width: 600px;
  padding: 4px 12px;
  border-radius: 1rem;
  background-color: var(--lc-system);
  color: var(--lc-accent-ink);
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  overflow-wrap: break-word;
}

.lc-root .lc-failed {
  color: var(--lc-danger);
  font-size: 12px;
}

.lc-root .lc-replying {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  border-top: 1px solid var(--lc-paper-3);
  background-color: var(--lc-paper-2);
}

.lc-root .lc-replying .lead-text,
.lc-root .lc-replying .sub-text {
  display: block;
}

.lc-root .lc-quick-replies {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 240px;
  margin: 0;
  padding: 4px 0;
  overflow-y: auto;
  list-style: none;
  border-top: 1px solid var(--lc-paper-3);
  background-color: var(--lc-paper);
}

.lc-root .lc-quick-reply {
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 8px 16px;
  border: 0;
  background: none;
  color: var(--lc-ink);
  text-align: left;
}

.lc-root .lc-quick-reply:hover {
  background-color: var(--lc-paper-2);
}

.lc-root .lc-holder {
  border: 1px solid var(--lc-holder-rule);
  background-color: var(--lc-holder);
  color: var(--lc-ink);
}

.lc-root .lc-reply {
  border: 1px solid var(--lc-paper-3);
  border-radius: 4px;
  padding: 4px 8px;
  margin-bottom: 4px;
  background-color: var(--lc-paper-2);
  color: var(--lc-ink-2);
  font-size: 13px;
}

.lc-root .lc-media {
  display: block;
  max-width: 240px;
  max-height: 320px;
  border-radius: 8px;
  cursor: pointer;
}

.lc-root video.lc-media {
  cursor: auto;
}

.lc-root .lc-file {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 260px;
  padding: 8px 12px;
  border: 1px solid var(--lc-paper-3);
  border-radius: 8px;
  background-color: var(--lc-paper);
  color: var(--lc-ink);
}

.lc-root .lc-file-icon {
  font-size: 28px;
  color: var(--lc-danger);
}

.lc-root .lc-tick {
  font-size: 13px;
}

.lc-root .lc-typing {
  padding: 4px 16px;
  color: var(--lc-ink-2);
  font-size: 12px;
  font-style: italic;
}

.lc-root .lc-unsent {
  color: var(--lc-ink-2);
  font-style: italic;
}

.lc-root .lc-time {
  color: var(--lc-ink-2);
  font-size: 12px;
  text-align: right;
}

.lc-root .lc-note {
  max-width: 480px;
  margin: 8px auto;
  padding: 8px 12px;
  border: 1px solid var(--lc-note-rule);
  border-radius: 4px;
  background-color: var(--lc-note);
  color: var(--lc-ink);
  font-size: 13px;
  white-space: pre-line;
}

.lc-root .lc-older {
  min-height: 32px;
}

.lc-root .lc-ticket {
  border-bottom: 1px solid var(--lc-paper-3);
  padding: 8px 0;
}

.lc-root .lc-ticket:last-child {
  border-bottom: 0;
}

@media (prefers-reduced-motion: reduce) {
  .lc-root *,
  .lc-root *::before,
  .lc-root *::after {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/app/livechat/livechat.css"],"names":[],"mappings":"AAAA;;;0EAG0E;AAC1E,qKAAqK;AACrK,mIAAmI;;AAEnI;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,sCAAsC;IACtC,qCAAqC;EACvC;AACF","sourcesContent":["/* Hallmark · shape: app screen · genre: modern-minimal · theme: brand · redesign: full\n * paper: #ffffff · accent: #4461f2 · display: DM Sans · body: DM Sans\n * nav: kept (Dashlite shell) · signature: the three-pane inbox of chat-platform · states: loading, empty, no access, full\n * axes: white/dm-sans/blue · posture: settled · contrast: pass · v2.0.0 */\n/* Hallmark · pre-emit critique: P4 H4 E4 S3 R4 V4 · weakest: S, the inbox is a twin of chat-platform by request, the sidebar badges carry the Live Chat difference */\n/* base.css is not imported: a global reset would restyle every CRM page; its focus and motion rules are scoped to .lc-root below */\n\n:root {\n  --lc-accent: #4461f2;\n  --lc-accent-ink: #ffffff;\n  --lc-paper: #ffffff;\n  --lc-paper-2: #f5f6fa;\n  --lc-paper-3: #e5e9f2;\n  --lc-ink: #364a63;\n  --lc-ink-2: #526484;\n  --lc-muted: #8094ae;\n  --lc-note: #fff7d6;\n  --lc-note-rule: #f4bd0e;\n  --lc-system: #485fee;\n  --lc-danger: #c4323f;\n  --lc-holder: #f7f5f5;\n  --lc-holder-rule: #050505;\n  --lc-focus: #4461f2;\n  --lc-font: \"DM Sans\", sans-serif;\n  --lc-dur: 120ms;\n}\n\n.lc-root {\n  font-family: var(--lc-font);\n}\n\n.lc-root :focus-visible {\n  outline: 2px solid var(--lc-focus);\n  outline-offset: 2px;\n}\n\n.lc-root .lc-tab {\n  height: 40px;\n  cursor: pointer;\n  color: var(--lc-ink);\n}\n\n.lc-root .lc-tab.is-active {\n  color: var(--lc-accent);\n}\n\n.lc-root .lc-search {\n  background-color: var(--lc-paper-3);\n  margin-bottom: 16px;\n}\n\n.lc-root .lc-filter-on {\n  background-color: var(--lc-accent);\n  color: var(--lc-accent-ink);\n}\n\n.lc-root .lc-filter-menu {\n  min-width: 220px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.lc-root .lc-item.is-selected {\n  background-color: var(--lc-paper-2);\n}\n\n.lc-root .lc-preview.is-unread {\n  color: var(--lc-ink);\n  font-weight: 700;\n}\n\n.lc-root .lc-msg {\n  max-width: 425px;\n  min-width: 120px;\n  font-size: 15px;\n  white-space: pre-line;\n  overflow-wrap: break-word;\n}\n\n.lc-root .lc-system {\n  max-width: 600px;\n  padding: 4px 12px;\n  border-radius: 1rem;\n  background-color: var(--lc-system);\n  color: var(--lc-accent-ink);\n  font-size: 12px;\n  font-style: italic;\n  font-weight: 600;\n  overflow-wrap: break-word;\n}\n\n.lc-root .lc-failed {\n  color: var(--lc-danger);\n  font-size: 12px;\n}\n\n.lc-root .lc-replying {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--lc-paper-3);\n  background-color: var(--lc-paper-2);\n}\n\n.lc-root .lc-replying .lead-text,\n.lc-root .lc-replying .sub-text {\n  display: block;\n}\n\n.lc-root .lc-quick-replies {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  max-height: 240px;\n  margin: 0;\n  padding: 4px 0;\n  overflow-y: auto;\n  list-style: none;\n  border-top: 1px solid var(--lc-paper-3);\n  background-color: var(--lc-paper);\n}\n\n.lc-root .lc-quick-reply {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 16px;\n  border: 0;\n  background: none;\n  color: var(--lc-ink);\n  text-align: left;\n}\n\n.lc-root .lc-quick-reply:hover {\n  background-color: var(--lc-paper-2);\n}\n\n.lc-root .lc-holder {\n  border: 1px solid var(--lc-holder-rule);\n  background-color: var(--lc-holder);\n  color: var(--lc-ink);\n}\n\n.lc-root .lc-reply {\n  border: 1px solid var(--lc-paper-3);\n  border-radius: 4px;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n  background-color: var(--lc-paper-2);\n  color: var(--lc-ink-2);\n  font-size: 13px;\n}\n\n.lc-root .lc-media {\n  display: block;\n  max-width: 240px;\n  max-height: 320px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.lc-root video.lc-media {\n  cursor: auto;\n}\n\n.lc-root .lc-file {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 260px;\n  padding: 8px 12px;\n  border: 1px solid var(--lc-paper-3);\n  border-radius: 8px;\n  background-color: var(--lc-paper);\n  color: var(--lc-ink);\n}\n\n.lc-root .lc-file-icon {\n  font-size: 28px;\n  color: var(--lc-danger);\n}\n\n.lc-root .lc-tick {\n  font-size: 13px;\n}\n\n.lc-root .lc-typing {\n  padding: 4px 16px;\n  color: var(--lc-ink-2);\n  font-size: 12px;\n  font-style: italic;\n}\n\n.lc-root .lc-unsent {\n  color: var(--lc-ink-2);\n  font-style: italic;\n}\n\n.lc-root .lc-time {\n  color: var(--lc-ink-2);\n  font-size: 12px;\n  text-align: right;\n}\n\n.lc-root .lc-note {\n  max-width: 480px;\n  margin: 8px auto;\n  padding: 8px 12px;\n  border: 1px solid var(--lc-note-rule);\n  border-radius: 4px;\n  background-color: var(--lc-note);\n  color: var(--lc-ink);\n  font-size: 13px;\n  white-space: pre-line;\n}\n\n.lc-root .lc-older {\n  min-height: 32px;\n}\n\n.lc-root .lc-ticket {\n  border-bottom: 1px solid var(--lc-paper-3);\n  padding: 8px 0;\n}\n\n.lc-root .lc-ticket:last-child {\n  border-bottom: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lc-root *,\n  .lc-root *::before,\n  .lc-root *::after {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
